export const NAV_CONFIG = [
    { keyIndex:1, pathname: "/", label: "Home", roles: ["user", "admin", "guest"] },
    { keyIndex:2, pathname: "/dashboard", label: "Dashboard", roles: ["user", "admin"] },
    { keyIndex:3, pathname: "/archive", label: "Archive", roles: ["user", "admin"] },
    // { keyIndex:4, pathname: "/prices", label: "Prices", roles: ["user", "admin", "guest"] },
    { keyIndex:5, pathname: "/about", label: "About Us", roles: ["user", "admin", "guest"] },
    { keyIndex:6, pathname: "/contact", label: "Contact Us", roles: ["user", "admin", "guest"] },
    { keyIndex:7, pathname: "/settings", label: "Settings", roles: ["user", "admin"] },
    // { keyIndex:8, pathname: "/register", label: "Register", roles: ["user", "admin", "guest"] },
    // { keyIndex:9, pathname: "/login", label: "Login", roles: ["user", "admin", "guest"] },
];